import { render, staticRenderFns } from "./Acc.vue?vue&type=template&id=2625d4c8&scoped=true&"
import script from "./Acc.vue?vue&type=script&lang=js&"
export * from "./Acc.vue?vue&type=script&lang=js&"
import style0 from "./Acc.vue?vue&type=style&index=0&id=2625d4c8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2625d4c8",
  null
  
)

export default component.exports